import React from 'react';
import { withRouter } from 'next/router';
import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import TopNav from '@glowforge/ui-common/components/navigation/top-nav';
import ButtonLink from '@glowforge/ui-common/components/button-link';
import { GLOWFORGE_LANDING_PAGE, GLOWFORGE_STORE } from '../../route-constants';
import { withUser, userContextPropType } from '../../context/UserContext';
import { withFeatureFlags } from '../../context/FeatureFlagsContext';
import NavItem from './nav-item';
import getNavbarConfig from './config';

import './navbar.less';

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      belowTheFold: false,
      showMobileNav: false,
    };

    this.throttledScroll = _.throttle(this.handleScroll, 200);
  }

  componentDidMount() {
    // Only need scroll listener for homepage.
    if (this.isHome()) {
      window.addEventListener('scroll', this.throttledScroll);
    }
  }

  componentWillUnmount() {
    this.removeScrollListener();
  }

  getBuyButton = () => {
    const { includeBuyButton, ctaLocation, ctaText } = this.props;
    const { belowTheFold } = this.state;
    if (!includeBuyButton) {
      return null;
    }

    const classNames = classnames('buyButton', 'button', 'primary', 'small', {
      // Only hide buyButton if on homepage and not been below the fold.
      hidden: !belowTheFold && this.isHome(),
      // buyButton is inverted colors only on homepage
      inverted: this.isHome(),
    });

    return (
      <div className='buyButtonSection'>
        <ButtonLink
          url={ctaLocation}
          className={classNames}
          type='primary'
          size='small'
          text={ctaText} />
      </div>
    );
  }

  /**
   * Keep track of whether the user has scrolled below the fold.
   * Will remove the scroll listener once belowTheFold is true.
   */
  handleScroll = () => {
    const { belowTheFold } = this.state;
    const belowTheFoldHeight = window.innerHeight * 0.8;
    // only set state if it will be different
    if (!belowTheFold && (window.scrollY > belowTheFoldHeight)) {
      this.setState({ belowTheFold: true });
      this.removeScrollListener();
    }
  }

  /**
   * Toggle mobile navigation visibility
   */
  toggleMobileNav() {
    const { showMobileNav } = this.state;
    this.setState({
      showMobileNav: !showMobileNav,
    });
  }

  /**
   * Helper to remove scrollListener
   */
  removeScrollListener() {
    this.throttledScroll.cancel();
    window.removeEventListener('scroll', this.throttledScroll);
  }

  isHome() {
    const { router: { pathname } } = this.props;
    return pathname === GLOWFORGE_LANDING_PAGE.BASE_URI;
  }

  render() {
    const { user, featureFlags } = this.props;
    const buyButton = this.getBuyButton();
    const config = getNavbarConfig(featureFlags);

    return (
      <TopNav
        NavigationItem={NavItem}
        marketing // Use the marketing page nav style
        user={user}
        buttonSection={buyButton}
        primaryRoutes={config.routes}
        userRoutes={config.userRoutes}
        userSecondaryLinks={config.userSecondaryLinks} />
    );
  }
}

Navbar.propTypes = {
  ctaText: PropTypes.string,
  ctaLocation: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  featureFlags: PropTypes.object,
  includeBuyButton: PropTypes.bool,
  router: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  ...userContextPropType,
};

Navbar.defaultProps = {
  ctaText: 'Shop Now',
  ctaLocation: GLOWFORGE_STORE.BASE_URI,
  featureFlags: {},
  includeBuyButton: true,
};

export default withFeatureFlags(withUser(withRouter(Navbar)));
